import * as React from "react";
import type { SVGProps } from "react";
const SvgTram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 15H8c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1M15 15h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.55 0-1 .45-1 1s.45 1 1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m7.11 21-.22.44c-.18.35-.53.55-.9.55L6 22a1.01 1.01 0 0 1-.9-1.45l1.305-2.61A3.01 3.01 0 0 1 4 15V6c0-2.21 1.79-4 4-4h8c2.21 0 4 1.79 4 4v3.838q.028.17 0 .335V15a3.01 3.01 0 0 1-2.419 2.943l1.309 2.617c.25.49.05 1.09-.45 1.34-.14.07-.3.11-.45.11L18 22c-.37 0-.72-.2-.9-.55l-.225-.45zm1.5-3h6.765l.5 1H8.11zm-.554-2H17c.55 0 1-.45 1-1v-3.665c-1.45.372-3.22.665-5.88.665H12c-2.658 0-4.501-.3-6-.678V15c0 .55.45 1 1 1h.948q.054-.003.108 0M8 4h3v5.991c-2.198-.077-3.727-.381-5-.735V6c0-1.1.9-2 2-2m5 0v5.997c2.243-.064 3.74-.373 5-.731V6c0-1.1-.9-2-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTram;
